
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ThroughProvider } from "react-through";

import { store, history } from "./core-units/config/storeConfig";
import * as serviceWorker from "./serviceWorker";
import ScrollToTop from './core-units/routes/windowScroll'
import App from "./containers/App";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "../node_modules/jquery/dist/jquery.js";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import 'antd/dist/reset.css';

const TheApp = () => {
  return (
    <ThroughProvider>
      <App />
    </ThroughProvider>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <HistoryRouter history={history}>
      <ScrollToTop />
      <Routes>
        {/* root route delegates to the application component tree */}
        <Route path="/*" element={<TheApp />} />
      </Routes>
      </HistoryRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
